module.exports = __webpack_public_path__ + "static/img/atPlus.cb285c93.png";